import { Input, Space } from 'antd';
import cn from 'classnames';
import { ChangeEventHandler, FC, useCallback, useMemo } from 'react';
import styles from './RecordsListHeader.module.scss';
import { RecordsListHeaderProps } from './RecordsListHeader.props';

const RecordsListHeader: FC<RecordsListHeaderProps> = ({
  primaryButton,
  onSearch,
  otherActions,
  searchOnTop,
  filter,
  searchQuery = '',
  searchElement,
}) => {
  const handleOnChange: ChangeEventHandler<HTMLInputElement> = useCallback(
    (e) => {
      if (onSearch) onSearch(e.target.value);
    },
    [onSearch],
  );

  const searchMemo = useMemo(
    () => (
      <Input.Search
        placeholder="Search..."
        onChange={handleOnChange}
        onSearch={onSearch}
        value={searchQuery}
        allowClear
      />
    ),
    [handleOnChange, onSearch, searchQuery],
  );

  return (
    <div className={cn(styles.recordsListHeaderWrapper, { [styles.searchTopWrapper]: searchOnTop })}>
      <div className={styles.recordsListHeader}>
        <div className={styles.primary}>{primaryButton || null}</div>
        <div className={styles.searchContainer}>
          <Space>
            {filter}
            {searchElement || searchMemo}
          </Space>
        </div>
        <div className={styles.otherActionsContainer}>{otherActions || null}</div>
      </div>
    </div>
  );
};

export { RecordsListHeader };
